/** A fresh idempotency key. crypto.randomUUID needs a secure context; the fallback keeps old or odd browsers working. */
export function newKey(): string {
  const c = globalThis.crypto as Crypto | undefined;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  const hex = (n: number) => Array.from({ length: n }, () => Math.floor(Math.random() * 16).toString(16)).join('');
  return `${hex(8)}-${hex(4)}-4${hex(3)}-8${hex(3)}-${hex(12)}`;
}

/** Local time for a place, falling back to the phone's zone when the zone name is unknown. */
export function timeIn(iso: string, timeZone: string): string {
  try {
    return new Intl.DateTimeFormat('en-GB', { timeStyle: 'short', timeZone }).format(new Date(iso));
  } catch {
    return new Intl.DateTimeFormat('en-GB', { timeStyle: 'short' }).format(new Date(iso));
  }
}
